// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { LinkToParentCardArgs_abstract } from './../../abstract/SagaBase/Defines/LinkToParentCardArgs_abstract';
export class LinkToParentCardArgs extends LinkToParentCardArgs_abstract {}
